import type { PublicRouletteDisplay, PublicRoulettePrize } from '@/lib/landing-roulette'
import type { RoletaSlotState } from '@/pages/CampanhasPage/roletaSlotTypes'
import type {
  CouponPrizePayload,
  LuckyNumberPrizePayload,
  NonePrizePayload,
  PixPrizePayload,
  RoulettePrizeType,
} from '@/lib/roulette'

function couponDisplay(payload: CouponPrizePayload | null): Record<string, unknown> {
  if (!payload) return {}
  const out: Record<string, unknown> = {}
  if (payload.description !== undefined && payload.description !== '') {
    out.description = payload.description
  }
  if (payload.discount_percent !== undefined) out.discount_percent = payload.discount_percent
  if (payload.discount_amount !== undefined) out.discount_amount = payload.discount_amount
  if (payload.min_purchase !== undefined) out.min_purchase = payload.min_purchase
  if (payload.valid_until !== undefined && payload.valid_until !== '') {
    out.valid_until = payload.valid_until
  }
  return out
}

function luckyDisplay(payload: LuckyNumberPrizePayload | null): Record<string, unknown> {
  if (!payload) return {}
  const q = payload.quantity ?? 1
  return { quantity: q }
}

function pixDisplay(payload: PixPrizePayload | null): Record<string, unknown> {
  if (!payload) return {}
  return { amount: payload.amount ?? 0 }
}

function noneDisplay(payload: NonePrizePayload | null): Record<string, unknown> {
  if (!payload) return {}
  const label = payload.label ?? '😞'
  return { label }
}

function slotToPublicPrize(slot: RoletaSlotState): PublicRoulettePrize {
  const type: RoulettePrizeType = slot.prize_type
  let display: Record<string, unknown> = {}
  switch (type) {
    case 'coupon':
      display = couponDisplay(slot.prize_payload as CouponPrizePayload | null)
      break
    case 'lucky_number':
      display = luckyDisplay(slot.prize_payload as LuckyNumberPrizePayload | null)
      break
    case 'pix':
      display = pixDisplay(slot.prize_payload as PixPrizePayload | null)
      break
    case 'none':
      display = noneDisplay(slot.prize_payload as NonePrizePayload | null)
      break
    default:
      display = {}
  }
  return {
    position: slot.position,
    prize_type: type,
    display: display as PublicRoulettePrize['display'],
  }
}

/**
 * Monta a estrutura esperada pelo LandingLuckyWheel a partir do rascunho do editor (sem GET).
 */
export function buildPublicDisplayFromDraft(
  positions: number,
  slots: RoletaSlotState[]
): PublicRouletteDisplay {
  const sorted = [...slots].sort((a, b) => a.position - b.position)
  const prizes: PublicRoulettePrize[] = sorted
    .filter((s) => s.position >= 1 && s.position <= positions)
    .map(slotToPublicPrize)

  return {
    positions,
    prizes,
  }
}
